import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { registerUser } from "./userSlice";
import { useLocation, useNavigate } from "react-router-dom";

function Signup() {
  document.title = "SignUp - To Do App";

  const dispatch = useAppDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  // @ts-ignore
  let from = location.state?.from?.pathname || "/";

  const user = useAppSelector((state) => state.user.token);
  const responseError = useAppSelector((state) => state.user.errors);
  const responseStatus = useAppSelector((state) => state.user.status);
  // Local State
  const [formData, setFormData] = React.useState({
    email: "",
    password: "",
    fullName: "",
  });
  const [error, setError] = React.useState({
    email: "",
    password: "",
    fullName: "",
  });
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError({ ...error, email: "", password: "" });
    console.log(formData);
    await dispatch(registerUser(formData));
    setIsSubmitting(false);
  };

  useEffect(() => {
    if (user) {
      // Send them back to the page they tried to visit when they were
      // redirected to the login page. Use { replace: true } so we don't create
      // another entry in the history stack for the login page.  This means that
      // when they get to the protected page and click the back button, they
      // won't end up back on the login page, which is also really nice for the
      // user experience.
      navigate(from, { replace: true });
    }
  }, [isSubmitting]);

  if (!user) {
    return (
      <div className="signup">
        <h2>Sign up</h2>
        {responseStatus === "failed" && (
          <ul className="errors-list">
            {responseError?.map((err, index) => (
              <li key={index}>{err}</li>
            ))}
          </ul>
        )}
        <form autoComplete="off" onSubmit={handleSubmit}>
          <label id="fullName">Full Name</label>
          <input
            required
            type="text"
            id="fullName"
            name="fullName"
            onChange={handleChange}
            placeholder="full name"
            maxLength={20}
            minLength={3}
          />
          <label id="email">Email</label>
          <input
            required
            type="email"
            id="email"
            name="email"
            onChange={handleChange}
            placeholder="email"
          />
          <label id="password">password</label>
          <input
            required
            type="password"
            id="password"
            name="password"
            onChange={handleChange}
            placeholder="password"
            maxLength={20}
            minLength={6}
          />
          <p>
            By signing up, you agree to our Terms , Data Policy and Cookies
            Policy .
          </p>
          <button className="btn-primary" disabled={isSubmitting} type="submit">
            Sign up
          </button>
          <p>
            Have an account ? <Link to="/login">Login</Link>
          </p>
        </form>
      </div>
    );
  }
  return <div></div>;
}

export default Signup;
